export default [
  {
    name: 'project_updates',
    component_path: 'modules/templates/blocks/project/ProjectUpdates',
  }
]